import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from './api/baseApi.ts';
import { errorMiddleware } from './middleware/errorMiddleware.ts';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, errorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
